import type { BoxProps } from '@chakra-ui/react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { useRef } from 'react'
import type { HoverableRiskId } from './package/OfferPackageGrid'
import { useGridHover } from './package/OfferPackageGrid'

export const cellBorderColor = 'gray.100'

export const OfferCellWrapper = ({
  children,
  sx,
  riskId,
  ...rest
}: BoxProps & { riskId: HoverableRiskId }) => {

  const ref = useRef<HTMLElement | undefined>(null)
  const { setRiskId, removeRiskId } = useGridHover(ref, riskId)

  return (
    <Box
      ref={ref}
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gap: 1,
        px: 2,
        py: 2,
        lineHeight: '20px',
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderColor: `${cellBorderColor}`,
        ...sx,
      }}
      onMouseEnter={setRiskId}
      onMouseLeave={removeRiskId}
      {...rest}
    >
      {children}
    </Box>
  )
}

export const BlankOfferCell = ({ riskId }: { riskId: HoverableRiskId }) => {
  return (
    <OfferCellWrapper sx={{ justifyContent: 'end', justifyItems: 'end' }} riskId={riskId}>
      <Flex>
        <Text>&nbsp;</Text>
      </Flex>
    </OfferCellWrapper>
  )
}